<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Detalhes da Denúncia") }}</h1>

    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div class="row">
      <div class="col-md-12">
        <print-content>
          <table
            class="
              table
              b-table b-table-stacked-md
              table-bordered table-sm
              bg-white
            "
          >
            <tbody>
              <tr>
                <td colspan="4">
                  <h4 class="text-center">Detalhes da Denúncia</h4>
                </td>
              </tr>
              <tr>
                <td>
                  ID: <strong>{{ item.id }}</strong>
                </td>
                <td>
                  PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                </td>
                <td>
                  CADASTRADO:
                  <strong>{{ item.cadastrado }}</strong>
                </td>
                <td>
                  ATUALIZADO:
                  <strong>{{ item.atualizado }}</strong>
                </td>
              </tr>
              <tr v-if="item.tecnico">
                <td colspan="2">
                  TÉCNICO RESPONSÁVEL:
                  <strong>{{ item.tecnico }}</strong>
                </td>
                <td colspan="2">
                  UNIDADE:
                  <strong>{{ item.unidade.nome }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  NOME DA VITIMA:
                  <strong>{{ item.nome_vitima }}</strong>
                </td>
                <td>
                  IDADE:
                  <strong>{{ item.idade_vitima }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  STATUS:
                  <strong v-html="item.status_nome"></strong>
                </td>
                <td colspan="2">
                  DATA DA DENÚNCIA :
                  <strong>{{ item.data_denuncia }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  CANAL DE RECEBIMENTO:
                  <strong>{{
                    verificarValueArray(
                      item.canal_denuncia,
                      $root.arrays.canal_denuncia
                    )
                  }}</strong>
                </td>
                <td colspan="2">
                  DENUNCIANTE:
                  <strong>{{
                    verificarValueArray(
                      item.denunciante,
                      $root.arrays.denunciate
                    )
                  }}</strong>
                </td>
              </tr>
              <tr v-if="item.denunciante == 6">
                <td>
                  NOME DO DENUNCIANTE:
                  <strong>{{ item.denunciante_nome }}</strong>
                </td>
                <td>
                  TELEFONE DO DENUNCIANTE:
                  <strong>{{ item.denunciante_telefone }}</strong>
                </td>
                <td>
                  DATA DE NASC. DO DENUNCIANTE:
                  <strong>{{ item.denunciante_data_nascimento }}</strong>
                </td>
                <td>
                  ENDEREÇO DO DENUNCIANTE:
                  <strong>{{ item.denunciante_endereco }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  TÉCNICO DA VISITA:
                  <strong>{{ item.tecnico_id }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  ENDEREÇO DA OCORRÊNCIA:
                  <strong>{{ item.endereco_denuncia }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  OBSERVAÇÃO:
                  <div v-html="item.descricao"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <print-footer 
            v-if=" item.responsavel.assinatura_digital" 
            :tecnico="item.responsavel" 
            class="mt-0" 
            :assinatura=" item.responsavel.assinatura_digital"
            :wpp="wpp"
            :email="email"
          />
                   
          <p class="text-muted">{{ app_cidade }}, {{ app_data_atual }}</p>

          <div class="row pt-4 px-0 d-flex justify-content-end no-print">
            <div class="col-auto px-2 text-right">
              <form-toggle
                  grid="12"
                  mt="0"
                  v-model="email"
                  label="Email"
              />
              <form-toggle
                  grid="12"
                  mt="0"
                  v-model="wpp"
                  label="Telefone/WhatsApp"
              />
              <router-link
                :to="`/dashboard/denuncias/edit/${item.id}`"
                class="btn btn-default"
              >
                <i class="mdi mdi-arrow-left" />
              </router-link>

              <a class="btn btn-sm py-1 btn-primary" @click="print()">
                <i class="mdi mdi-printer mdi-18px" />
              </a>
            </div>
          </div>
        </print-content>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      email: true,
      wpp: true
    };
  },
  mounted() {
    this.getItem();
  },
  methods: {
    getItem() {
      axios
        .get(`api/dashboard/denuncias/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push("/dashboard/denuncias/");
        });
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
  },
};
</script>

<style>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
  }
  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
